<template>
  <div>
    <div
      class="text-subtitle-2 info--text"
      v-text="$t('labels.attachedFiles')"
    />
    <v-card
      class="mb-3"
      outlined
    >
      <v-card-text>
        <v-list
          color="transparent"
          dense
        >
          <v-list-item
            v-for="(file, i) in files"
            :key="getFileId(file)"
          >
            <v-list-item-content>
              <v-list-item-title>
                <span v-text="file.name" />
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon
                color="red"
                @click="remove(i)"
              >
                {{ mdiCloseCircle }}
              </v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mdiCloseCircle } from '@mdi/js';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'BaseFileList',
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mdiCloseCircle,
    };
  },
  created() {
    this._fileIdMap = new Map();
  },
  methods: {
    getFileId(file) {
      if (!this._fileIdMap.has(file)) {
        this._fileIdMap.set(file, uuidv4());
      }
      return this._fileIdMap.get(file);
    },
    remove(index) {
      this.$emit('remove', index);
    },
  },
};
</script>
